// Modo oscuro compartido por las herramientas internas (petición de André
// 27/08). Los estilos ya tienen definidos los colores de la variante `.dark`,
// así que basta con poner esa clase en <html> y recordar la elección.
import { useCallback, useEffect, useState } from "react";

const KEY = "edTheme";

export const applyTheme = (dark: boolean) => {
  document.documentElement.classList.toggle("dark", dark);
  try {
    localStorage.setItem(KEY, dark ? "dark" : "light");
  } catch {
    /* navegador sin almacenamiento: se queda solo para esta sesión */
  }
};

const initial = (): boolean => {
  try {
    const saved = localStorage.getItem(KEY);
    if (saved) return saved === "dark";
  } catch {
    /* ignora */
  }
  return window.matchMedia?.("(prefers-color-scheme: dark)").matches ?? false;
};

export const useDarkMode = (): [boolean, () => void] => {
  const [dark, setDark] = useState(initial);
  useEffect(() => {
    applyTheme(dark);
  }, [dark]);
  // El interruptor no cambia de identidad entre repintados: así quien lo pase
  // a un componente memorizado no lo obliga a volver a montarse.
  const alternar = useCallback(() => setDark((v) => !v), []);
  return [dark, alternar];
};
